<form [formGroup]="formGroup" id="step2Form">
  <div class="step2-form-container">
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.maritalStatus as maritalStatus"
          class="standard-form-field maritalStatus-field required-field">
          <label for="applicantMaritalStatus" [class.invalid]="maritalStatus.touched && maritalStatus.invalid">
            {{ 'PERSONAL_DATA_FORM.MARITAL-STATUS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="applicantMaritalStatus"
              panelClass="standard-select"
              [placeholder]="'PERSONAL_DATA_FORM.MARITAL-STATUS.PLACEHOLDER' | translate"
              [formControl]="maritalStatus"
              (keydown)="firstInputKeydown($event)"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                maritalStatus.touched && maritalStatus.invalid ? 'applicantMaritalStatusError' : null
              "
              [attr.aria-invalid]="maritalStatus.touched && maritalStatus.invalid ? 'true' : null">
              <mat-option *ngFor="let item of selectsValues.MARITAL_STATUS" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="maritalStatus.touched && maritalStatus.invalid" id="applicantMaritalStatusError">
              {{ maritalStatus.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.education as education" class="standard-form-field education-field required-field">
          <label for="applicantEducation" [class.invalid]="education.touched && education.invalid">
            {{ 'PERSONAL_DATA_FORM.EDUCATION.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="applicantEducation"
              panelClass="standard-select"
              [placeholder]="'PERSONAL_DATA_FORM.EDUCATION.PLACEHOLDER' | translate"
              [formControl]="education"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="education.touched && education.invalid ? 'applicantEducationError' : null"
              [attr.aria-invalid]="education.touched && education.invalid ? 'true' : null">
              <mat-option *ngFor="let item of selectsValues.EDUCATION" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="education.touched && education.invalid" id="applicantEducationError">
              {{ education.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.pesel as pesel" class="standard-form-field pesel-field">
          <label for="peselInput" [class.invalid]="pesel.touched && pesel.invalid">
            {{ 'PERSONAL_DATA_FORM.PESEL.INFIELD-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              id="peselInput"
              matInput
              #peselInput
              placeholder="{{ 'PERSONAL_DATA_FORM.PESEL.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-describedby]="pesel.touched && pesel.invalid ? 'peselInputError' : null"
              [attr.aria-invalid]="pesel.touched && pesel.invalid ? 'true' : null"
              formControlName="pesel" />

            <!-- ERROR -->
            <mat-error *ngIf="pesel.touched && pesel.invalid" id="peselInputError">
              {{ pesel.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.telephoneNumber as telephoneNumber"
          class="standard-form-field telephoneNumber-field required-field">
          <label for="telephoneNumberInput" [class.invalid]="telephoneNumber.touched && telephoneNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.INFIELD-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              id="telephoneNumberInput"
              matInput
              #telephoneNumberInput
              placeholder="{{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                telephoneNumber.touched && telephoneNumber.invalid ? 'telephoneNumberInputError' : null
              "
              [attr.aria-invalid]="telephoneNumber.touched && telephoneNumber.invalid ? 'true' : null"
              formControlName="telephoneNumber" />

            <!-- ERROR -->
            <mat-error *ngIf="telephoneNumber.touched && telephoneNumber.invalid" id="telephoneNumberInputError">
              {{ telephoneNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.descriptionHeight as descriptionHeight"
          class="standard-form-field descriptionHeight-field required-field">
          <label
            for="applicantDescriptionHeight"
            [class.invalid]="descriptionHeight.touched && descriptionHeight.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              id="applicantDescriptionHeight"
              matInput
              type="number"
              min="50"
              max="280"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                descriptionHeight.touched && descriptionHeight.invalid ? 'applicantDescriptionHeightError' : null
              "
              [attr.aria-invalid]="descriptionHeight.touched && descriptionHeight.invalid ? 'true' : null"
              [formControl]="descriptionHeight"
              placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.PLACEHOLDER' | translate }}" />

            <!-- ERROR -->
            <mat-error
              *ngIf="descriptionHeight.touched && descriptionHeight.invalid"
              id="applicantDescriptionHeightError">
              {{ descriptionHeight.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.descriptionColourOfEyes as descriptionColourOfEyes"
          class="standard-form-field descriptionColourOfEyes-field required-field">
          <label
            for="applicantDescriptionColourOfEyes"
            [class.invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="applicantDescriptionColourOfEyes"
              panelClass="standard-select"
              [placeholder]="'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.PLACEHOLDER' | translate"
              [formControl]="descriptionColourOfEyes"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid
                  ? 'applicantDescriptionColourOfEyesError'
                  : null
              "
              [attr.aria-invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid ? 'true' : null">
              <mat-option *ngFor="let item of selectsValues.EYES" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid"
              id="applicantDescriptionColourOfEyesError">
              {{ descriptionColourOfEyes.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="controls.descriptionSpecialMarks as descriptionSpecialMarks"
        class="standard-form-field widened-field descriptionSpecialMarks-field">
        <label
          for="applicantDescriptionSpecialMarks"
          [class.invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid">
          {{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.MAIN-LABEL' | translate }}
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantDescriptionSpecialMarks"
            type="text"
            maxLength="200"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.PLACEHOLDER' | translate }}"
            [required]="false"
            [attr.aria-required]="false"
            [attr.aria-describedby]="
              descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid
                ? 'applicantDescriptionSpecialMarksError'
                : null
            "
            [attr.aria-invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid ? 'true' : null"
            [formControl]="descriptionSpecialMarks" />

          <!-- ERROR -->
          <mat-error
            *ngIf="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid"
            id="applicantDescriptionSpecialMarksError">
            {{ descriptionSpecialMarks.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.residenceStreet as residenceStreet"
          class="standard-form-field residenceStreet-field required-field">
          <label for="applicantResidenceStreet" [class.invalid]="residenceStreet.touched && residenceStreet.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceStreet"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                residenceStreet.touched && residenceStreet.invalid
                  ? 'applicantResidenceStreetError applicantResidenceStreetTooltip'
                  : 'applicantResidenceStreetTooltip'
              "
              [attr.aria-invalid]="residenceStreet.touched && residenceStreet.invalid ? 'true' : null"
              [formControl]="residenceStreet" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantResidenceStreetTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="residenceStreet.touched && residenceStreet.invalid" id="applicantResidenceStreetError">
              {{ residenceStreet.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceHouseNumber as residenceHouseNumber"
          class="standard-form-field residenceHouseNumber-field required-field">
          <label
            for="applicantResidenceHouseNumber"
            [class.invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceHouseNumber"
              type="text"
              maxLength="20"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                residenceHouseNumber.touched && residenceHouseNumber.invalid
                  ? 'applicantResidenceHouseNumberError applicantResidenceHouseNumberTooltip'
                  : 'applicantResidenceHouseNumberTooltip'
              "
              [attr.aria-invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid ? 'true' : null"
              [formControl]="residenceHouseNumber" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantResidenceHouseNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceHouseNumber.touched && residenceHouseNumber.invalid"
              id="applicantResidenceHouseNumberError">
              {{ residenceHouseNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="controls.residenceApartmentNumber as residenceApartmentNumber"
        class="standard-form-field residenceApartmentNumber-field">
        <label
          for="applicantResidenceApartmentNumber"
          [class.invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantResidenceApartmentNumber"
            type="text"
            maxLength="20"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
            [required]="false"
            [attr.aria-required]="false"
            [attr.aria-describedby]="
              residenceApartmentNumber.touched && residenceApartmentNumber.invalid
                ? 'applicantResidenceApartmentNumberError applicantResidenceApartmentNumberTooltip'
                : 'applicantResidenceApartmentNumberTooltip'
            "
            [attr.aria-invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid ? 'true' : null"
            [formControl]="residenceApartmentNumber" />

          <!-- TOOLTIP -->
          <app-cr-form-field-tooltip
            [id]="'applicantResidenceApartmentNumberTooltip'"
            class="info-suffix-icon"
            matSuffix
            [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
          </app-cr-form-field-tooltip>

          <!-- ERROR -->
          <mat-error
            *ngIf="residenceApartmentNumber.touched && residenceApartmentNumber.invalid"
            id="applicantResidenceApartmentNumberError">
            {{ residenceApartmentNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="additional-border" [class.border-enabled]="mode === 'employee'">
      <div class="row extra-margin">
        <div class="nowrap-container">
          <div
            *ngIf="controls.residenceCity as residenceCity"
            class="standard-form-field residenceCity-field required-field">
            <label for="applicantResidenceCity" [class.invalid]="residenceCity.touched && residenceCity.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantResidenceCity"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  residenceCity.touched && residenceCity.invalid ? 'applicantResidenceCityError' : null
                "
                [attr.aria-invalid]="residenceCity.touched && residenceCity.invalid ? 'true' : null"
                [formControl]="residenceCity" />

              <!-- ERROR -->
              <mat-error *ngIf="residenceCity.touched && residenceCity.invalid" id="applicantResidenceCityError">
                {{ residenceCity.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.residencePostalCode as residencePostalCode"
            class="standard-form-field residencePostalCode-field required-field">
            <label
              for="applicantResidencePostalCode"
              [class.invalid]="residencePostalCode.touched && residencePostalCode.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantResidencePostalCode"
                type="text"
                maxLength="6"
                minLength="6"
                [mask]="'99-999'"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  residencePostalCode.touched && residencePostalCode.invalid
                    ? 'applicantResidencePostalCodeError'
                    : null
                "
                [attr.aria-invalid]="residencePostalCode.touched && residencePostalCode.invalid ? 'true' : null"
                [formControl]="residencePostalCode" />

              <!-- ERROR -->
              <mat-error
                *ngIf="residencePostalCode.touched && residencePostalCode.invalid"
                id="applicantResidencePostalCodeError">
                {{ residencePostalCode.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="nowrap-container">
          <div
            *ngIf="controls.residenceVoivodeshipDetailsId as residenceVoivodeshipDetailsId"
            class="standard-form-field residenceVoivodeshipName-field required-field">
            <label
              for="applicantResidenceVoivodeshipName"
              [class.invalid]="residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" *ngIf="voivodeships$ | async as voivodeships">
              <mat-select
                id="applicantResidenceVoivodeshipName"
                panelClass="['standard-select', longer-select']"
                [placeholder]="'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.PLACEHOLDER' | translate"
                [formControl]="residenceVoivodeshipDetailsId"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid
                    ? 'applicantResidenceVoivodeshipNameError'
                    : null
                "
                [attr.aria-invalid]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid ? 'true' : null
                "
                (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()">
                <mat-option *ngFor="let voivo of voivodeships" [value]="voivo.id">
                  {{ 'COMMON.VOIVODESHIPS.' + voivo.key | translate }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid"
                id="applicantResidenceVoivodeshipNameError">
                {{ residenceVoivodeshipDetailsId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="lookingForVoivodeship" id="lookingForVoivodeshipSpinner" role="status" aria-live="polite">
            <span class="sr-only">
              {{ 'COMMON.LAYOUT.LOADING' | translate }}
            </span>

            <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="mode === 'employee'">
        <div
          *ngIf="controls.residenceDistrictId as residenceDistrictId"
          class="standard-form-field residenceDistrict-field">
          <label
            for="applicantResidenceDistrictId"
            [class.invalid]="residenceDistrictId.touched && residenceDistrictId.invalid">
            {{ 'COMMON.LABEL.DISTRICT' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="districts$ | async as districts">
            <mat-select
              id="applicantResidenceDistrictId"
              [panelClass]="['standard-select', 'longer-select']"
              [placeholder]="'COMMON.PLACEHOLDER.SELECT_DISTRICT' | translate"
              [formControl]="residenceDistrictId"
              [disabled]="!controls.residenceVoivodeshipDetailsId?.value"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-disabled]="!controls.residenceVoivodeshipDetailsId?.value"
              [attr.aria-describedby]="
                residenceDistrictId.touched && residenceDistrictId.invalid ? 'applicantResidenceDistrictIdError' : null
              "
              [attr.aria-invalid]="residenceDistrictId.touched && residenceDistrictId.invalid ? 'true' : null"
              appMatOptionHeight
              [appMatOptionHeightValue]="50"
              class="heightened-select">
              <mat-option *ngIf="loadingDistricts$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
              </mat-option>

              <mat-option *ngFor="let district of districts" [value]="district.id">
                {{ district.MOS_name.toUpperCase() }} ({{ district.MOS_extra_name.toUpperCase() }})
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceDistrictId.touched && residenceDistrictId.invalid"
              id="applicantResidenceDistrictIdError">
              {{ residenceDistrictId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceMunicipalityId as residenceMunicipalityId"
          class="standard-form-field residenceMunicipality-field">
          <label
            for="applicantResidenceMunicipalityId"
            [class.invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid">
            {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="municips$ | async as municips">
            <mat-select
              id="applicantResidenceMunicipalityId"
              [panelClass]="['standard-select', 'longer-select']"
              [placeholder]="'COMMON.PLACEHOLDER.SELECT_MUNICIPALITY' | translate"
              [formControl]="residenceMunicipalityId"
              [disabled]="!controls.residenceDistrictId?.value"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-disabled]="!controls.residenceDistrictId?.value"
              [attr.aria-describedby]="
                residenceMunicipalityId.touched && residenceMunicipalityId.invalid
                  ? 'applicantResidenceMunicipalityIdError'
                  : null
              "
              [attr.aria-invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid ? 'true' : null"
              appMatOptionHeight
              [appMatOptionHeightValue]="50">
              <mat-option *ngIf="loadingMunicips$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
              </mat-option>

              <mat-option *ngFor="let municip of municips" [value]="municip.id">
                {{ municip.MOS_name.toUpperCase() }} ({{ municip.MOS_type.toUpperCase() }})
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceMunicipalityId.touched && residenceMunicipalityId.invalid"
              id="applicantResidenceMunicipalityIdError">
              {{ residenceMunicipalityId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceCityListedId as residenceCityListedId"
          class="standard-form-field residenceCityListed-field">
          <label
            for="applicantResidenceCityListedId"
            [class.invalid]="residenceCityListedId.touched && residenceCityListedId.invalid">
            {{ 'COMMON.LABEL.CITY_MOS' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="cities$ | async as cities">
            <mat-select
              id="applicantResidenceCityListedId"
              [panelClass]="['standard-select', 'longer-select']"
              appMatOptionHeight
              (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()"
              [placeholder]="'COMMON.PLACEHOLDER.SELECT_CITY' | translate"
              [formControl]="residenceCityListedId"
              [appMatOptionHeightValue]="50"
              [disabled]="!controls.residenceMunicipalityId?.value"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-disabled]="!controls.residenceMunicipalityId?.value"
              [attr.aria-describedby]="
                residenceCityListedId.touched && residenceCityListedId.invalid
                  ? 'applicantResidenceCityListedIdError'
                  : null
              "
              [attr.aria-invalid]="residenceCityListedId.touched && residenceCityListedId.invalid ? 'true' : null">
              <mat-option *ngIf="loadingCities$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
              </mat-option>

              <mat-option *ngFor="let city of cities" [value]="city.id">
                {{ city.MOS_name.toUpperCase() }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceCityListedId.touched && residenceCityListedId.invalid"
              id="applicantResidenceCityListedIdError">
              {{ residenceCityListedId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="zip-warning-overflow-container" *ngIf="voivoIsBeeingUsed && !userACKDocumentsReset">
        <h4 class="mat-h4">{{ 'PERSONAL_DATA_FORM.IF_YOU_CHANGE_VOIVO_DOCUMENTS_RESET' | translate }}</h4>
        <button
          mat-raised-button
          color="primary"
          (click)="voivoChangeACK()"
          (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()">
          {{ 'APPLICATION.I_UNDERSTAND_AND_WANT_TO_PROCEED' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
